module.exports = __webpack_public_path__ + "img/case_hantu.0d2f7e6e.png";